import type { RefObject } from 'react';
import { useEffect, useRef } from 'react';

export const useResizeObserver = (
  ref: RefObject<Element | null>,
  callback: ResizeObserverCallback
) => {
  const cbRef = useRef(callback);

  useEffect(() => {
    cbRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const observer = new ResizeObserver(
      (entries: ResizeObserverEntry[], obs: ResizeObserver) =>
        cbRef.current(entries, obs)
    );
    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [ref]);
};
